import styled from 'styled-components';

export interface TooltipProps {
    width?: number;
    center?: boolean;
}

export const CommonTooltipWrapper = styled.div<TooltipProps>`
    .elem-wrapper {
        display: inline-block;
        position: relative;
        font-weight: 500;
    }
    .elem-wrapper .tooltip-show {
        visibility: hidden;
        padding: 10px 5px;
        position: absolute;
        z-index: 100;
        background-color: #f3f3d9;
        border: 1px solid #78785e;
        text-align: center;

        width: ${(props) => (props.width ? props.width : '200')}px;
        top: 30px;
        ${(props) => props.center && 'margin-left: -60px;'}
    }

    .elem-wrapper:hover .tooltip-show {
        visibility: visible;
    }
`;
